import React from 'react'
import { usePlane } from '@react-three/cannon'
import useStore from './../hooks/Store';

export const Pocket = ({ ...props }) => {
    const { position = [0, 1.4, .93] } = props;
    const { actions } = useStore();

    const onCollide = (e) => {
        if (e.body.userData?.value) {
            // register hit
            actions.collectPuck(Number.parseInt(e.body.userData.value));

            // put it back on the wheel
            e.body.api.velocity.set(0, 0, 0)
            e.body.api.position.set(-.4, 1.7, 0);
            e.body.api.angularVelocity.set(0, 0, 0);
            e.body.api.rotation.set(0, 0, 0);
        }
    }

    usePlane(() => ({
        mass: 0,
        position: position,
        collisionResponse: false,
        onCollideEnd: onCollide
    }))

    // don't render anything as this is basically trigger for when puck fall into a pocket
    return (
        <></>
    );
}
export default Pocket;